import { Empty, Modal, Pagination, Spin } from "antd";
import { ReactNode, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { IBookTypeData } from "../../apiservice/userService.type";
import { userGetBooks } from "../../apiservice/userService";
import NoAudioBookFound from "../sharedcomponents/NoBookFoundInCategory";

export const BookCardsComp = () => {
  const navigate = useNavigate();
  const params = useParams();
  const id = params.categoryId || "0";
  const title = params.categoryName || "All Books";

  const [books, setBooks] = useState<IBookTypeData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [hasSearched, setHasSearched] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const pageSize = 20;

  useEffect(() => {
    fetchBooks();
    setCurrentPage(1); // Reset to first page when tag changes
  }, [params]);

  const fetchBooks = async () => {
    try {
      const bookData =
        id === "0"
          ? await userGetBooks({ page: 1, pageSize })
          : await userGetBooks({
              categoryId: id || "",
              page: 1,
              pageSize,
            });

      if (bookData) {
        setBooks(bookData?.data);
        setTotalPage(bookData?.meta?.total);
      } else {
        setError("Books not found");
      }
    } catch (err) {
      setError("Failed to load book data");
    } finally {
      setLoading(false);
    }

    setHasSearched(true);
    setCurrentPage(1);
  };

  const fetchBooksPage = async () => {
    try {
      const bookData =
        id === "0"
          ? await userGetBooks({ page: currentPage, pageSize })
          : await userGetBooks({
              categoryId: id || "",
              page: currentPage,
              pageSize,
            });

      if (bookData) {
        setBooks(bookData?.data);
        setTotalPage(bookData?.meta?.total);
      } else {
        setError("Books not found");
      }
    } catch (err) {
      setError("Failed to load book data");
    } finally {
      setLoading(false);
    }

    setHasSearched(true);
  };

  useEffect(() => {
    if (hasSearched) {
      fetchBooksPage();
    }
  }, [currentPage]);

  if (loading) {
    // Default text color will be dark:text-stone-100 due to global styles
    return (
      <div className="p-4 text-center">
        <Spin size="large" /> &nbsp; Loading book Summary...
      </div>
    );
  }

  if (error || !books.length) {
    return (
      <div className="p-4 text-center text-red-500">
        {error || <NoAudioBookFound></NoAudioBookFound>}
      </div>
    );
  }

  return (
    <div className="p-4 grid">
      <h3 className="mb-4 font-bold text-lg text-gray-900 dark:text-stone-100">
        {title}
      </h3>

      {books.length > 0 ? (
        <>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {(books || []).map((item, index: number) => (
              <div
                key={index}
                className="flex flex-col w-full shadow-lg pb-4 rounded-2xl overflow-hidden bg-white dark:bg-stone-800"
              >
                <Link
                  className="flex flex-col items-center text-blue-800 dark:text-blue-400 hover:text-blue-500 dark:hover:text-blue-300"
                  to={`/users/book-details/${item.id}/${item.title}`}
                >
                  <div className="w-full h-48 ">
                    <img
                      src={`${process.env.PUBLIC_URL + item.coverImageUrl}`}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  {/* Text color inherited from Link */}
                  <p className="mt-2 p-2 text-center font-medium">
                    {item.title}
                  </p>
                </Link>
              </div>
            ))}
          </div>
          <div className="mt-4 flex justify-center">
            <Pagination
              current={currentPage}
              onChange={setCurrentPage}
              total={totalPage}
              pageSize={pageSize}
              hideOnSinglePage
            />
          </div>
        </>
      ) : (
        <Empty
          description={
            title
              ? `No books found under the category "${title}"`
              : "Select a new category to see books"
          }
        />
      )}
    </div>
  );
};

export default BookCardsComp;
